import React from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'
import { ICON_LIST } from '../../../../../../../lib/constants'
import IconItem from '../IconItem'
import NoUserIconData from '../../NoUserIconData'
import styles from '../../FeatureIconEditor.module.scss'
import typeIcons from '../../../../../../../assets/featureType'

function IconFavorites(props) {
	return (
		<>
			{props.listItems.length ? (
				<div className={styles.iconItemsList}>
					{props.listItems.map((li, i) => {
						return <IconItem key={i} image={li.image} name={li.name} title={li.title} />
					})}
				</div>
			) : (
				<NoUserIconData />
			)}
		</>
	)
}

IconFavorites.propTypes = {
	listItems: PropTypes.array
}

export default connect((model) => {
	const { preferences: { favorites } } = model.features
	const listItems = []
	for (let ili = 0; ili < ICON_LIST.length; ili++) {
		const { display, key } = ICON_LIST[ili]
		if (favorites.icons.includes(key)) {
			listItems.push({
				image: typeIcons[display.replace(/ /g, '')],
				name: key,
				title: display,
			})
		}
	}
	return {
		listItems,
	}
})(IconFavorites)
